import { Tenant } from '../config/tenants';
import { compensaTranslations } from './tenants/compensa';
import { interriskTranslations } from './tenants/interrisk';
import { tuwTranslations } from './tenants/tuw';

export const translations = {
  [Tenant.COMPENSA]: {
    ...compensaTranslations,
  },
  [Tenant.INTER_RISK]: {
    ...interriskTranslations,
  },
  [Tenant.TUW]: {
    ...tuwTranslations,
  },
};
